import { ActionTree, MutationTree } from 'vuex';
import getYear from 'date-fns/getYear';
import getQuarter from 'date-fns/getQuarter';
import subQuarters from 'date-fns/subQuarters';
import { MyPortfolioWizardState } from '~/types/store/my-portfolio-wizard';
import { RootState } from '~/types/store/index';
import { Mutation, MutationUpsertDealQuarterArgs } from '~/types/graphql';
import UpsertDealQuarterMutation from '~/apollo/mutations/UpsertDealQuarterMutation';

const getInitialState = (): MyPortfolioWizardState => {
  const lastQuarterDate = subQuarters(new Date(), 1);

  return {
    year: getYear(lastQuarterDate),
    quarter: getQuarter(lastQuarterDate),
    quota: null,
    revenue: null,
  };
};

export const state = getInitialState;

export const mutations: MutationTree<MyPortfolioWizardState> = {
  updateQuota(state, { quota }) {
    state.quota = quota || null;
  },
  updateRevenue(state, { revenue }) {
    state.revenue = revenue || null;
  },
  resetState(state) {
    Object.assign(state, getInitialState());
  },
};

export const actions: ActionTree<MyPortfolioWizardState, RootState> = {
  async upsertDealsQuarter({ state }) {
    if (
      this.app.apolloProvider &&
      state.quota !== null &&
      state.quota > 0 &&
      state.revenue !== null &&
      state.revenue > 0
    ) {
      await this.app.apolloProvider.defaultClient.mutate<Mutation['upsertDealQuarter'], MutationUpsertDealQuarterArgs>({
        mutation: UpsertDealQuarterMutation,
        variables: {
          input: {
            year: state.year,
            quarter: state.quarter,
            quota: state.quota,
            revenue: state.revenue,
          },
        },
      });
    }
  },
};
